import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface FerryScheduleLocationStore {
	startLocationId: string;
	endLocationId: string;
	setLocations(
		locations: Partial<{
			startLocationId: string;
			endLocationId: string;
		}>,
	): void;
}

export const useFerryScheduleLocationStore = create(
	persist<FerryScheduleLocationStore>(
		(set, get) => ({
			startLocationId: '',
			endLocationId: '',
			setLocations(locations) {
				set(locations);
			},
		}),
		{
			name: 'ferry-schedule-locations', // name of the item in the storage (must be unique)
			storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
		},
	),
);
